import Resource from "./resource";
import request from "../utils/request";

class RoleResource extends Resource {
  constructor() {
    // super("accounts");
    super("roles");
  }
  /**
   *
   * @param {String} name
   * @returns {AxiosPromise}
   */
  createPermission(name) {
    return request.post(`${this.uri}/permissions/`, { name });
  }
  /**
   *
   * @returns {AxiosPromise}
   */
  getPermissions() {
    return request.get(`${this.uri}/permissions/all`);
  }
  /**
   *
   * @param {Number | String} id
   * @param {Number | String} permissionId
   * @returns {AxiosPromise}
   */
  removeRolePermission(id, permissionId) {
    return request.delete(`${this.uri}/${id}/permissions/`, {
      id: permissionId,
    });
  }
}

export default new RoleResource();
